import React from "react";
import { Flex, styled } from "@acko-tech/building-blocks.ui.common";

export const Container = styled(Flex)`
  padding: 2rem 3rem;
  position: absolute;
  max-width: 472px;
  max-height: 418px;
  height: fit-content;
  z-index: 100;
  background: #ffffff;
  box-shadow: 0px 4px 35px rgba(8, 12, 41, 0.1);
  border-radius: 12px;
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
  ${props => {
    return { ...props.styles };
  }}
`;

const InputModal: React.FC<{ clickHandler?: Function; styles?: any }> = ({
  children,
  clickHandler,
  styles
}) => {
  return (
    <Container
      onClick={e => {
        e.stopPropagation();
        clickHandler && clickHandler();
      }}
      styles={styles}
    >
      {children}
    </Container>
  );
};

export default InputModal;
